export const modifyPhoneForm = [
    {
        cols: [
            {
                formGroup: 'modifyPhoneForm',
                class: 'col-12',
                title: 'Modificar teléfono',
                titleClass: 'text-center form-title-2 mt-5'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-md-6 col-10',
                item: 'input',
                type: 'tel',
                label: 'Teléfono',
                placeholder: 'Teléfono',
                formControlName: 'phone',
                inputClass: 'text-input'
            },
            {
                class: 'col-md-6 col-10',
                item: 'button',
                type: 'regular',
                placeholder: 'MODIFICAR EL TELÉFONO',
                inputClass: 'form-button mt-md-4 mt-0 btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
];
